import React, { useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { Link } from 'react-router-dom'
import Select from 'react-select'
import { useSelector } from 'react-redux'
import { capitalizeAndRemoveUnderscore } from '../../helper/function'

const AdminControlFilter = ({ showFilter, setShowFilter, handlePagination, setFilterData, setIsRefresh }) => {
  const { allRegion } = useSelector(({ region }) => region)
  const { allAdminRole } = useSelector(({ adminControl }) => adminControl)
  // eslint-disable-next-line no-unused-vars
  const [collapse, setCollapse] = useState(true)
  const { handleSubmit, control, trigger, reset } = useForm({})

  const onSubmit = (data) => {
    console.log('data :>> ', data)
    setFilterData({
      name: data?.name,
      region: data?.region?.region_id,
      admin_type: data?.admin_type?.value
    })
    handlePagination(1, 10)
    setShowFilter(!showFilter)
    setIsRefresh(true)
  }

  const handleFilterclear = async () => {
    reset({
      name: '',
      region: '',
      admin_type: ''
    })
    setFilterData({})
    handlePagination(1, 10)
    setShowFilter(!showFilter)
    setIsRefresh(true)
  }

  return (
    <div className={`toggle-sidebar ${showFilter ? 'open-filter' : ''}`}>
      <div className="sidebar-layout-filter">
        <div className="sidebar-header">
          <h5>Filter</h5>
          <Link
            to="#"
            className="sidebar-closes"
            onClick={() => {
              setShowFilter(!showFilter)
            }}
          >
            <i className="fa-regular fa-circle-xmark" />
          </Link>
        </div>
        <div className="sidebar-body">
          <div className="title">Admin Control</div>
          <form onSubmit={handleSubmit(onSubmit)}>
            {/* Product */}
            <div className="accordion" id="accordionMain1">
              <div
                id="collapseOne"
                className={collapse ? 'collapse show' : 'collapse'}
                aria-labelledby="headingOne"
                data-bs-parent="#accordionExample1"
              >
                <div className="card-body-chat">
                  <div className="row">
                    <div className="col-lg-12 col-sm-12">
                      <div className="form-group">
                        <label>Admin Name</label>
                        <Controller
                          name="name"
                          control={control}
                          render={({ field: { value, onChange } }) => (
                            <>
                              <input
                                className="form-control bg-transparent dark_border"
                                autoComplete="off"
                                value={value}
                                type="text"
                                placeholder="Search Admin"
                                onChange={(val) => {
                                  onChange(val)
                                  trigger('name')
                                }}
                              />
                            </>
                          )}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12 col-sm-12">
                      <div className="form-group input_text border-remove dark_border_divs">
                        <label>Admin Type</label>
                        <Controller
                          name="admin_type"
                          control={control}
                          render={({ field }) => (
                            <Select
                              {...field}
                              className={`react-selectcomponent form-control select-box-filed`}
                              getOptionLabel={(option) => capitalizeAndRemoveUnderscore(option?.key)}
                              getOptionValue={(option) => option?.value}
                              options={allAdminRole || []}
                              isSearchable={true}
                              isClearable
                              placeholder={`Select Admin Type`}
                              classNamePrefix="select_kanakku"
                            />
                          )}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12 col-sm-12">
                      <div className="form-group input_text border-remove dark_border_divs">
                        <label>Region</label>
                        <Controller
                          name="region"
                          control={control}
                          render={({ field }) => (
                            <Select
                              {...field}
                              className={`react-selectcomponent form-control select-box-filed`}
                              getOptionLabel={(option) => `${option.region}`}
                              getOptionValue={(option) => `${option.region_id}`}
                              options={allRegion || []}
                              isClearable
                              isSearchable={true}
                              placeholder={`Select Region`}
                              classNamePrefix="select_kanakku"
                              defaultValue={''}
                            />
                          )}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* /Category */}
            <div className="filter-buttons">
              <button
                type="submit"
                // onClick={}
                // disabled={key.length > 0 ? false : true}
                className="d-inline-flex align-items-center justify-content-center btn w-100 btn-primary"
              >
                {/* {key.length > 0 ? 'Apply' : 'Select Admin'} */}
                Apply
              </button>
              <button
                type="button"
                onClick={handleFilterclear}
                // disabled={searchText.value == '' && key.length == 0 ? true : false}
                className="d-inline-flex align-items-center justify-content-center btn w-100 btn-secondary"
              >
                Reset
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default AdminControlFilter
